/**
 * Hooks and fixes for 3rd party libraries
 */

require('./Hooks/nunjucks')
